/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MetricListRequest extends models.AIGovernanceRequestBase {
    getFixupPrototypeFunction() { return MetricListRequest.fixupPrototype; }

    static newInstance(model: Partial<MetricListRequest>): MetricListRequest {
        let obj = Object.assign(new MetricListRequest(), model);
        MetricListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MetricListRequest>): MetricListRequest {
        if (!model) return null;
        return MetricListRequest.newInstance(<MetricListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MetricListRequest) {
        if (!obj) return;

        models.MetricListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MetricListRequest): boolean {
        if (models.AIGovernanceRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MetricListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Indicates if this is a cost metric request (true) or usage metric request (false)
     */
    is_cost_metric: boolean;

    /**
     * Service Account Ids to Filter
     */
    service_account_ids: Array<string>;

}
